import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { BaseCollectionComponent } from './base-collection.component';

@Directive()
export class BaseAutocompleteComponent extends BaseCollectionComponent {
  @Input() public valuePrimitive = true;
  @Input() public filterable = true;

  @Output() public readonly filterChange = new EventEmitter<string>();
}
